import { createBlock } from 'factories/block';
import { InteractionProps, repeat } from './interaction';
import { createLayout } from 'factories/layout';
import FlipCard_default from 'assets/FlipCard_loop.gif'; // 'assets/FlipCard_default.svg';
import { colors } from 'styles/variables';
import { createMediaBlock } from './media';
import { Block, cloneBlock, Blocks } from '@chameleoncreator/creator-app';
import { flatten } from 'factories/utils';
import { createContinueBtn } from './continueBtn';
import uuid from 'uuidv4';
import { getSId } from '../utils';

const { lPink, lGrey0, lGrey2, lTeal0 } = colors;

const contentForColumn = (count: number) => (i: number) => {
  return [
    () => createBlock('Text', [], { props: { useBackgroundControls: true } }),
    () => createBlock('TopicPortalContainer', [], {}),
  ][i];
};

export const createTopicPortalInteractionBlock = props => {
  const { style } = props as any;

  //

  return createBlock(
    'Interaction',
    [
      createLayout(
        contentForColumn(0),
        // props.columnCount,
        // props.columnsReversed
        0,
        true
      ),
      createBlock('SingleColumnLayout', [
        createBlock('Column', [createContinueBtn(style)], {
          props: {
            flexDirection: 'row',
            alignItems: 'center',
            justifyContent: 'center',
            flexWrap: 'wrap',
          },
          meta: {
            subType: 'ButtonBlock',
          },
        }),
      ]),
    ],
    {
      props: {
        name: props.name,
        sId: getSId('interaction'),
        style: props.style,
      },
      meta: {
        subType: 'TopicPortal',
        // layout: `${props.columnCount === 0 ? 'OneColumn' : 'TwoColumns'}${
        //   props.columnsReversed ? 'Reversed' : ''
        // }`,
        layout: 'OneColumnReversed',
      },
    }
  );
};

export const create = createTopicPortalInteractionBlock;
export const interactionConfig = {};
